import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { exhaustMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return this.authService.user.pipe(
      take(1),
      exhaustMap((user) => {
        const allowedDomains = [
          'localhost',
          '127.0.0.1',
          'portal.afraway.org',
          'portaltest.afraway.org',
          'panel.afraway.org',
        ];

        const url = new URL(req.url, window.location.origin);
        const isApiUrl = allowedDomains.some((domain) =>
          url.hostname.includes(domain),
        );

        if (!user || !user.token || !isApiUrl) {
          return next.handle(req);
        }

        const modifiedReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${user.token}`),
        });

        return next.handle(modifiedReq);
      }),
    );
  }
}
